<div class="floating-alert ps-3">
  <div *ngFor="let alert of alerts" class="{{cssClass(alert)}} p-1 me-sm-2 me-md-1 me-lg-3 ">
    <div class="mb-0 d-flex">
      <span [innerHTML]="alert.message"></span>
      <a (click)="removeAlert(alert)" *ngIf="alert.closeButton" class="btn-close ms-1 font-size-12"></a>
    </div>
  </div>
</div>
